import { createCollector, createValidator, maxLength, required } from 'shared/validation'

const VALIDATE_RULES = {
    header: [required(), maxLength(500)],
}
export const timeIsUpValidator = createValidator(VALIDATE_RULES)
export const collectTimeIsUpErrors = createCollector(VALIDATE_RULES)
